import { gql } from "@apollo/client";

const GET_NOMINATION_PDF = gql`
query nominationPdf($uuid: String!, $id: String!)
    {nominationPdf(uuid: $uuid, id: $id)

    
}`
;

export default GET_NOMINATION_PDF;
